import { useNavigate } from "react-router-dom";
import { INewsFlat } from "../domain/models/News";
import ImagePlaceholderSVG from "./shared/svg/ImagePlaceholder";
import { useBreakpoint } from "../custom-hooks/useBreakpoint";
import { formatDateLong } from "../utils/DateUtils";

interface NewsCardProps {
    news: INewsFlat;
    showDate?: boolean;
}

export default function NewsCard({ news, showDate = true }: NewsCardProps) {
    const navigate = useNavigate();
    const { isTablet } = useBreakpoint();

    const handleClick = () => {
        navigate(`/news/${news.id}`);
    };

    return (
        <div
            onClick={handleClick}
            className={`flex flex-col cursor-pointer hover:opacity-90 transition-opacity ${
                isTablet ? "w-[336.5px] mx-auto" : "w-full h-full"
            }`}
        >
            <div
                className={`w-full flex-shrink-0 ${
                    isTablet ? "h-[200px] mb-4" : "h-[200px] md:h-[220px] lap:h-[250px] mb-4"
                }`}
            >
                {news.pictureExists?.() ? (
                    <img
                        src={news.getPictureUrl?.() || ""}
                        alt={news.title}
                        className="w-full h-full object-cover rounded-[6px]"
                    />
                ) : (
                    <div className="w-full h-full bg-gray-100 rounded-[6px] flex items-center justify-center">
                        <ImagePlaceholderSVG fill="#bec6d5" classname="w-20 h-20" />
                    </div>
                )}
            </div>

            <div className={`flex flex-col text-left ${isTablet ? "" : "flex-grow md:gap-2"}`}>
                <h3
                    className={`font-medium text-lg uppercase text-text-700 line-clamp-3 leading-[120%] ${
                        isTablet ? "mb-2" : "mb-2 md:mb-0"
                    }`}
                >
                    {news.title}
                </h3>

                <p
                    className={`font-normal text-base text-text-300 line-clamp-4 leading-[130%] ${
                        isTablet ? "" : "flex-grow mb-[6px] md:mb-0"
                    }`}
                >
                    {news.shortContent}
                </p>

                {showDate && news.createdAt && (
                    <span
                        className={`font-medium text-sm sm:text-base text-[#404040] ${
                            isTablet ? "mt-0" : "mt-auto md:pt-2"
                        }`}
                    >
                        {formatDateLong(news.createdAt)}
                    </span>
                )}
            </div>
        </div>
    );
}
